import { IonButton, IonCheckbox, IonContent, IonHeader, IonItem, IonList, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import { IonButtons } from '@ionic/react';
import { EventClassification } from '../../models/DeviceEvent';
import styles from '../DoorPolicyModal.module.css';
import { useState } from 'react';
import { useCommonTranslation, useModalTranslation } from '../../hooks/useTranslation';
import { getClassificationLabel } from '../../utils/doorPolicyTranslations';

export interface EditDoorPolicyClassificationPickerProps {
    classifications: EventClassification[];
    onSelectClassifications: (values: EventClassification[]) => void;
    onClose: () => void;
}

const EditDoorPolicyClassificationPicker = ({
    classifications,
    onSelectClassifications,
    onClose,
}: EditDoorPolicyClassificationPickerProps) => {
    const [selectedClassifications, setSelectedClassifications] = useState(classifications);
    const { t: tCommon } = useCommonTranslation();
    const { t: tModals } = useModalTranslation();
    const classificationOptions = Object.entries(EventClassification)
        .filter((entry) => typeof entry[1] === 'number')
        .map(([label, value]) => ({
            label: getClassificationLabel(tModals, value as EventClassification),
            value: value as EventClassification,
        }));
    const toggleClassification = (value: EventClassification) => {
        if (selectedClassifications.includes(value)) {
            setSelectedClassifications(selectedClassifications.filter((item) => item !== value));
        } else {
            setSelectedClassifications([...selectedClassifications, value]);
        }
    };

    return (
        <IonPage>
            <IonHeader translucent>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton color="medium" onClick={onClose}>
                            {tCommon('buttons.cancel')}
                        </IonButton>
                    </IonButtons>
                    {/* ios title mode keeps the title centered in md too */}
                    <IonTitle {...({ mode: 'ios' } as object)}>{tModals('door_policy.pickers.classification.title')}</IonTitle>
                    <IonButtons slot="end">
                        <IonButton
                            strong={true}
                            onClick={() => {
                                onSelectClassifications(selectedClassifications);
                                onClose();
                            }}
                        >
                            {tCommon('buttons.save')}
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen color="light">
                <section className={`${styles.wrapper} ${styles.section}`}>
                    <h2 className={styles.sectionLabel}>{tModals('door_policy.pickers.classification.heading')}</h2>
                    <IonList className={styles.listCard}>
                        {classificationOptions.map((option) => {
                            const isSelected = selectedClassifications.includes(option.value);
                            return (
                                <IonItem
                                    key={option.value}
                                    button
                                    detail={false}
                                >
                                    <IonCheckbox
                                        checked={isSelected}
                                        onIonChange={() => {
                                            toggleClassification(option.value);
                                        }}
                                    >
                                        {option.label}
                                    </IonCheckbox>
                                </IonItem>
                            );
                        })}
                    </IonList>
                </section>
            </IonContent>
        </IonPage>
    );
};

export const EditDoorPolicyClassificationPickerView = (props: EditDoorPolicyClassificationPickerProps) => (
    <EditDoorPolicyClassificationPicker {...props} />
);

export default EditDoorPolicyClassificationPicker;
